import { HeroCover } from 'components/HeroCover';

/** Pages that show a hero cover; each picks its cover in HERO_COVERS. */
export enum HeroPage {
  Market = 'market',
  Sales = 'sales',
  Operations = 'operations',
  Payments = 'payments',
  Shipments = 'shipments',
  ShipmentsHistory = 'shipmentsHistory',
  Customers = 'customers',
  ProfileGroups = 'profileGroups',
  UserProfiles = 'userProfiles',
  OrderEditHistory = 'orderEditHistory',
  Form = 'form',
  EditShipment = 'editShipment',
  EditShipments = 'editShipments',
  ShipmentTransactions = 'shipmentTransactions',
  Products = 'products',
  Quotes = 'quotes',
  CaseTransfers = 'caseTransfers',
  Packhouse = 'packhouse',
  Reports = 'reports',
  SellerSetup = 'sellerSetup',
  SellerLocations = 'sellerLocations',
  EditProfile = 'editProfile',
  SageExport = 'sageExport',
  GeneralSettings = 'generalSettings',
  ConfigProducts = 'configProducts',
  RouteRates = 'routeRates',
}

const DEFAULT_HERO_COVER = HeroCover.SunsetField;

/** The hero cover per page. Defaults to the market's; change an entry to give a page its own. */
export const HERO_COVERS: Record<HeroPage, HeroCover> = {
  [HeroPage.Market]: DEFAULT_HERO_COVER,
  [HeroPage.Sales]: DEFAULT_HERO_COVER,
  [HeroPage.Operations]: DEFAULT_HERO_COVER,
  [HeroPage.Payments]: DEFAULT_HERO_COVER,
  [HeroPage.Shipments]: DEFAULT_HERO_COVER,
  [HeroPage.ShipmentsHistory]: DEFAULT_HERO_COVER,
  [HeroPage.Customers]: DEFAULT_HERO_COVER,
  [HeroPage.ProfileGroups]: DEFAULT_HERO_COVER,
  [HeroPage.UserProfiles]: DEFAULT_HERO_COVER,
  [HeroPage.OrderEditHistory]: DEFAULT_HERO_COVER,
  [HeroPage.Form]: DEFAULT_HERO_COVER,
  [HeroPage.EditShipment]: DEFAULT_HERO_COVER,
  [HeroPage.EditShipments]: DEFAULT_HERO_COVER,
  [HeroPage.ShipmentTransactions]: DEFAULT_HERO_COVER,
  [HeroPage.Products]: DEFAULT_HERO_COVER,
  [HeroPage.Quotes]: DEFAULT_HERO_COVER,
  [HeroPage.CaseTransfers]: DEFAULT_HERO_COVER,
  [HeroPage.Packhouse]: DEFAULT_HERO_COVER,
  [HeroPage.Reports]: DEFAULT_HERO_COVER,
  [HeroPage.SellerSetup]: DEFAULT_HERO_COVER,
  [HeroPage.SellerLocations]: DEFAULT_HERO_COVER,
  [HeroPage.EditProfile]: DEFAULT_HERO_COVER,
  [HeroPage.SageExport]: DEFAULT_HERO_COVER,
  [HeroPage.GeneralSettings]: DEFAULT_HERO_COVER,
  [HeroPage.ConfigProducts]: DEFAULT_HERO_COVER,
  [HeroPage.RouteRates]: DEFAULT_HERO_COVER,
};
